import { PureComponent } from "react";

import { type BilledStatus } from "types/enum";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

import { BillAccountingStatusTag } from "entity/bill/common/BillAccountingStatusTag/BillAccountingStatusTag";

export class BillAccountingStatusCell extends PureComponent<IGridCellRenderProps<BilledStatus>> {
    render() {
        const { cellValue, field } = this.props;
        if (!cellValue) {
            return null;
        }
        return (
            <span data-testid={field.full}>
                <BillAccountingStatusTag status={cellValue} />
            </span>
        );
    }
}

export const columnBillAccountingStatus: IClientGridColumn<BilledStatus> = {
    columnType: GridColumnType.billAccountingStatus,
    Cell: BillAccountingStatusCell,
};
